const NOTIFICATION_SOUND_URL = '/sounds/notification.mp3'
let audioCache: HTMLAudioElement | null = null

export const playNotificationSound = () => {
  try {
    if (!audioCache) {
      audioCache = new Audio(NOTIFICATION_SOUND_URL)
      audioCache.volume = 0.3
    }
    audioCache.currentTime = 0
    audioCache.play().catch(() => {
      // Autoplay blocked — user hasn't interacted yet, silently ignore
    })
  } catch {
    // Audio API not supported in this environment
  }
}
